import { gql } from "@apollo/client";

// api_gateway: Mutation.consultRequestAdmin (ConsultRequestAdminOps, field ops).

export const CONSULT_REQUEST_ASSIGN = gql`
  mutation ConsultRequestAssign($id: ID!, $assigneeId: ID!, $version: Int32!) {
    consultRequestAdmin {
      assign(id: $id, assigneeId: $assigneeId, version: $version)
    }
  }
`;

export const CONSULT_REQUEST_CHANGE_STATUS = gql`
  mutation ConsultRequestChangeStatus(
    $id: ID!
    $toStatus: String!
    $reasonCode: String
    $reasonNote: String
    $version: Int32!
  ) {
    consultRequestAdmin {
      changeStatus(id: $id, toStatus: $toStatus, reasonCode: $reasonCode, reasonNote: $reasonNote, version: $version)
    }
  }
`;

export const CONSULT_REQUEST_ADD_NOTE = gql`
  mutation ConsultRequestAddNote($id: ID!, $content: String!) {
    consultRequestAdmin {
      addNote(id: $id, content: $content)
    }
  }
`;

export const CONSULT_REQUEST_UPLOAD_FILE = gql`
  mutation ConsultRequestUploadFile($id: ID!, $file: Upload!) {
    consultRequestAdmin {
      uploadFile(id: $id, file: $file)
    }
  }
`;

export const CONSULT_REQUEST_DELETE_FILE = gql`
  mutation ConsultRequestDeleteFile($id: ID!, $fileId: ID!) {
    consultRequestAdmin {
      deleteFile(id: $id, fileId: $fileId)
    }
  }
`;
